// extracted by mini-css-extract-plugin
module.exports = {"dashBoardArea":"cmpEnso_dashBoardArea__2d0B_"};